import { observer } from "mobx-react";

import {
    CustomDropTarget,
    onTransitionHover,
    allowedTransitionDragSources
} from "pages/editor/lib/timeline";
import Transition from "./transition";

import { TransitionsContainerWrapper } from "./transition.styles";

const spec = {
    hover: (props, monitor) => onTransitionHover(props.ui, monitor)
};

const collect = (connect) => ({
    connectDropTarget: connect.dropTarget()
});

/**
 * @typedef TransitionsContainerProps
 * @property {Function} connectDropTarget
 * @property {SectionStore} section
 * @property {EditorUIStore} ui
 */

/**
 * @summary - Transitions container, used to represent a layers transitions
 * @param {TransitionsContainerProps} props
 * @returns {React.Element}
 */
const TransitionsContainer = ({ connectDropTarget, section, ui }) => {
    return (
        <TransitionsContainerWrapper
            ref={connectDropTarget}
            data-testid={`transition-drop-${section.id}`}
        >
            {section.transitions.map((transition) => (
                <Transition
                    key={transition.id}
                    transition={transition}
                    section={section}
                    ui={ui}
                />
            ))}
        </TransitionsContainerWrapper>
    );
};

export default CustomDropTarget(
    allowedTransitionDragSources,
    spec,
    collect
)(observer(TransitionsContainer));
